import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'futureRemFilters/FETCH_REQUEST'
const FETCH_SUCCESS = 'futureRemFilters/FETCH_SUCCESS'
const FETCH_FAILURE = 'futureRemFilters/FETCH_FAILURE'

const initialState = {
  filters: [{
    id: 'CEO-0',
    fiscal_years: [],
    roles: [],
    members: []
  }],
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadFilter(options, cb = null) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/future_remunerations/filter`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      let createdIndex = state.filters.findIndex(i => i.id === payload.id)
      if (createdIndex < 0) {
        createdIndex = state.filters.length
      }
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        filters: Object.assign([...state.filters], {[createdIndex]: payload}),
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors: errors
      })
    default:
      return state
  }
}

